// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__29Js5","image":"style_image__vRh3l"};